<header class="sh" [class.sh--section]="size === 'section'" [class.sh--compact]="size === 'compact'">
  <div class="sh__top">
    <div class="sh__lead">
      @if (enableMenuToggle) {
        <button type="button" class="sh__iconbtn sh__iconbtn--ghost"
                title="Menü ein-/ausklappen" aria-label="Menü ein-/ausklappen"
                (click)="menuToggle.emit()">
          <i-tabler name="menu-2" />
        </button>
      }

      @if (showBackButton) {
        <button type="button" class="sh__iconbtn sh__iconbtn--bordered"
                title="Zurück" aria-label="Zurück" (click)="back.emit()">
          <i-tabler name="chevron-left" />
        </button>
      }

      @if (showFlipIcon) {
        <button type="button" class="sh__flip" [class.sh__flip--prominent]="iconProminent"
                title="Zurück" aria-label="Zurück" (click)="back.emit()">
          <span class="sh__flip-inner">
            <span class="sh__flip-face sh__flip-front"><i-tabler [name]="icon!" /></span>
            <span class="sh__flip-face sh__flip-back"><i-tabler name="chevron-left" /></span>
          </span>
        </button>
      }

      @if (showModuleIcon) {
        <span class="sh__icon" [class.sh__icon--prominent]="iconProminent">
          <i-tabler [name]="icon!" />
        </span>
      }

      <div class="sh__headings">
        @if (eyebrow) {
          <div class="sh__eyebrow">{{ eyebrow }}</div>
        }
        <div class="sh__titlerow">
          @if (titleMenu) {
            <span class="sh__switcher">
              <button type="button" class="sh__switcher-btn"
                      [class.is-open]="menuOpen()" [class.has-icon]="icon"
                      aria-haspopup="menu" [attr.aria-expanded]="menuOpen()"
                      (click)="toggleMenu()">
                @if (icon) {
                  <span class="sh__icon" [class.sh__icon--prominent]="iconProminent">
                    <i-tabler [name]="icon" />
                  </span>
                }
                <h1 class="sh__title">{{ title }}</h1>
                <span class="sh__chevron" [class.is-open]="menuOpen()"><i-tabler name="chevron-down" /></span>
              </button>
              @if (menuOpen()) {
                <div class="sh__menu" role="menu">
                  @if (titleMenu.menuLabel) {
                    <div class="sh__menu-label">{{ titleMenu.menuLabel }}</div>
                  }
                  @for (item of titleMenu.items; track item.value) {
                    @if (item.separator) {
                      <div class="sh__menu-sep" role="separator"></div>
                    } @else {
                      <div class="sh__menu-item" role="menuitem"
                           [class.is-selected]="item.value === titleMenu.value"
                           (click)="pick(item)">
                        @if (item.icon) {
                          <i-tabler class="sh__menu-item-icon" [name]="item.icon"
                             [class.is-selected]="item.value === titleMenu.value" />
                        }
                        <span class="sh__menu-item-text">
                          <span class="sh__menu-item-label">{{ item.label }}</span>
                          @if (item.sub) { <span class="sh__menu-item-sub">{{ item.sub }}</span> }
                        </span>
                        @if (item.value === titleMenu.value) {
                          <i-tabler class="sh__menu-item-check" name="check" />
                        }
                      </div>
                    }
                  }
                </div>
              }
            </span>
          } @else {
            <h1 class="sh__title">{{ title }}</h1>
          }
          <ng-content select="[sectionHeaderStatus]"></ng-content>
        </div>
      </div>
    </div>

    <div class="sh__actions">
      <ng-content select="[sectionHeaderActions]"></ng-content>
    </div>
  </div>

  @if (description) {
    <p class="sh__desc">{{ description }}</p>
  }
</header>
